<template>
  <div class="page-admin-block">
    <b-container class="py-4">
      <h3 class="mb-3">Бренды</h3>   
      <hr>
      <div class="ml-3">
      <h5 class="mt-1">Добавить бренд</h5>
            <b-row>
          <b-col lg="4" md="5" sm="7">
            <b-form>        
              <b-input-group class="my-1">
                <b-form-input
                  type="text"
                  label="name"
                  v-model="newcategory.name"
                  required
                  placeholder="Название"
                ></b-form-input>
              </b-input-group>          
              <b-input-group  class="my-1">
                <b-form-file
                  placeholder="Логотип"
                  ref="files"
                  @change="handleFileUpload"
                ></b-form-file>
              </b-input-group>       
        <img :src="imagesrc" v-if="imagesrc" width="100%">
        <b-button variant="success" block @click="addcategory()" title="Добавить бренд">
          <b-icon icon="plus"></b-icon>
        </b-button>
      </b-form>
    </b-col>
        </b-row>
      </div>
      <hr>
      <div class="ml-3">
      <h5 class="mt-1">Список брендов</h5>
        <b-row align-v="stretch"  align-h="center" justify-content-center class="mt-3">
            <b-col cols="6" md="4" lg="2" v-for="category in categories" :key="category.id" class="mb-4">
                <card-category :category="category" v-on:show-toast="showToast"></card-category>
              </b-col>
          </b-row>
        </div>
    </b-container>
    <b-toast
      :title="toast.title"
      v-model="toast.show"
      :variant="toast.variant"
      autoHideDelay="5000"
    >{{ toast.message }}</b-toast>
  </div>
</template>
<script>
import Authentication from "@/components/pages/Authentication";
import CardCategory from '@/components/components/CardCategory';
export default {
  data() {
    return {
      categories: [],
      imagesrc: null,
      toast: {
        show: false,
        title: "",
        variant: "",
        message: "",
      },
      newcategory: {
        name: "",
        new_images:"",
      },
    };
  },
  components:{        
    'card-category':CardCategory,
  },
  created() {
    this.getAllcategories();
  },
  methods: {
    showToast(data, update = true) {
      if (data) {
        if (data.success) {
          if(update){
            this.getAllcategories();
          }
          this.toast = {
            show: true,
            title: "Выполнено",
            variant: "success",
            message: data.message,
          };
        } else {
          this.toast = {
            show: true,
            title: "Ошибка",
            variant: "danger",
            message: data.message,
          };
        }
      }
    },
    async getAllcategories() {
      let { data } = await Authentication.sendRequest(
        this,
        "/api/v1/categories",
        "get"
      );
      if (data) {
        this.categories = data;
      }
    },
    async addcategory() {
      if(this.newcategory.new_images){
      let { data } = await Authentication.sendRequest(
        this,
        "/api/v1/addcategory",
        "post",
        this.newcategory
      );
      this.showToast(data);

      this.newcategory = {
        name: "",
        new_images:"",
      };
      this.$refs['files'].reset()
      this.imagesrc = null
     }else{
      this.showToast({ success: false, message: 'Не прикреплен логотип' });
     }
    },
    handleFileUpload(event){
        if(event.target.files.length>0){
            this.newcategory.new_images = event.target.files;   
            var reader = new FileReader();
            var vm = this;
            reader.onload = function(e) {
              vm.imagesrc = e.target.result;
            }
            reader.readAsDataURL(event.target.files[0]);
        }else{
            this.newcategory.new_images =''
            this.imagesrc = null
        }
        
    },    
  },
};
</script>
<style lang="scss">
</style>